export default {
  namespaced: true,
  name: 'SLSCondicaoPagamentoStore',
  state: () => ({
    currentCondPagto: {
      condicaopagamentoid: null,
      condicaopagamentodescricao: null,
    },
    condPagtos: [],
    loading: false,
    filters: {
      q: null,
      page: 1,
      perPage: 8,
      sortBy: null,
      sortDesc: null,
      condicaopagamentoid: null,
      condicaopagamentodescricao: null,
    },
  }),
  mutations: {
    SET_COND_PAGTOS(state, payload) {
      state.condPagtos = payload;
    },
    SET_CURRENT_COND_PAGTO(state, payload) {
      state.currentCondPagto = payload;
    },
    SET_FILTERS(state, payload) {
      state.filters = payload;
    },
    SET_CONDICAO_PAGAMENTO_ID(state, payload) {
      state.filters.condicaopagamentoid = payload;
    },
    SET_CONDICAO_PAGAMENTO_DESCRICAO(state, payload) {
      state.filters.condicaopagamentodescricao = payload;
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
  },
  getters: {
    GET_COND_PAGTOS: (state) => state.condPagtos,
    GET_CURRENT_COND_PAGTO: (state) => state.currentCondPagto,
    GET_FILTERS: (state) => state.filters,
    GET_CONDICAO_PAGAMENTO_ID: (state) => state.filters.condicaopagamentoid,
    GET_CONDICAO_PAGAMENTO_DESCRICAO: (state) => state.filters.condicaopagamentodescricao,
    GET_LOADING: (state) => state.loading,
  },
  actions: {
    resertFilters({ commit }) {
      commit('SET_FILTERS', {
        q: null,
        page: 1,
        perPage: 8,
        sortBy: null,
        sortDesc: null,
        condicaopagamentoid: null,
        condicaopagamentodescricao: null,
      });
    },
  },
};
